import Axios from 'axios'
/**
 * このファイルの各関数はダミーデータを読み込むものです。
 * ただし、locationだけは本番も利用しています。
 */

/**
 * Axiosオブジェクトを生成する
 */
const HTTP = () => {
  return Axios.create()
}

/**
 * Factory of HTTP
 */
function CreateHTTP (bearer) {
  const http = HTTP(bearer)
  http.interceptors.response.use(
    (response) => { return response },
    (error) => { return inteceptError(error) }
  )
  return http
}

/**
 * Create error object
 * TODO: 多言対応
 */
function inteceptError (error) {
  console.log(error)
  return { status: 999, code: '0000000', title: 'ネットワークエラー', message: 'ネットワークエラーが発生しました。通信環境の良いところで再度お試しください。' }
}

/**
 * Home画面おニュースリストを取得
 */
function getInfoList () {
  const path = './api/home-get-list.json'
  const http = CreateHTTP()
  return http.get(path)
}

/**
 * アカウント登録情報情報取得
 */
function getRegisterInfo () {
  const path = './api/get-register-info.json'
  const http = CreateHTTP()
  return http.get(path)
}

/**
 * 都道府県データ、各市町村データを取得
 */
function getLocations () {
  const path = './api/location.json'
  const http = CreateHTTP()
  return http.get(path)
}

/**
 * クーポンリストを取得
 */
function getCouponList () {
  const path = './api/get-coupon-list.json'
  const http = CreateHTTP()
  return http.get(path)
}

/**
 * クーポン詳細を取得
 */
function getCouponDetails (type) {
  const path = (type === 1) ? './api/get-coupon-details-coupon.json' : './api/get-coupon-details-prize.json'
  const http = CreateHTTP()
  return http.get(path)
}

/**
 * ユーザーデータを返す
 */
function getUserData () {
  const path = './api/get-user-data.json'
  const http = CreateHTTP()
  return http.get(path)
}

export const APIClient = CreateHTTP

export default {
  getInfoList,
  getRegisterInfo,
  getLocations,
  getCouponList,
  getCouponDetails,
  getUserData
}
